import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import SecurityRoutes from "security-app/routing/Routes";
import { LinkContainer } from "components/common";
import { MoreActions } from "components/common/EntityDataTable";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import { BootstrapModalConfirm, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { useDeleteAsset, useFetchAsset } from "security-app/hooks/useAssetsAPI";
import { useModalContext } from "common/contexts";
import useAssetPanel from "security-app/components/Assets/hooks/useAssetPanel";
import { getAssetFormModal } from "security-app/components/Assets/AssetModals/assetForms";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import usePermissions from "hooks/usePermissions";
import useAssetIdSearchParam from "security-app/hooks/useAssetIdSearchParam";
const AssetEntityActions = ({ asset, readOnly = false }) => {
  const { t } = useTranslation("enterprise_security_assets");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const fetchFullAsset = useFetchAsset();
  const { deselectEntity } = useSelectedEntities();
  const { setModal, setEntity } = useModalContext();
  const { saveAssetIdSearchParam } = useAssetIdSearchParam();
  const { push } = useHistory();
  const { deleteAsset } = useDeleteAsset();
  const { selectedAssetId, closeAssetDetails } = useAssetPanel();
  const sendTelemetry = useSendTelemetry("asset");
  const { isPermitted } = usePermissions();
  const canManageAssets = isPermitted("asset:edit");
  const formModal = getAssetFormModal(asset.type);
  const onEdit = async () => {
    const fullAsset = await fetchFullAsset(asset.id);
    if (!fullAsset) return;
    setEntity({ asset: fullAsset });
    setModal(formModal);
  };
  const onConfirmedDelete = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.ASSET_DELETED, {
      app_pathname: "security"
    });
    if (asset.id === selectedAssetId) {
      closeAssetDetails();
    }
    setShowDeleteModal(false);
    const deleted = await deleteAsset({ assetId: asset.id }).then(
      () => true,
      () => false
    );
    if (deleted) {
      deselectEntity(asset.id);
    }
  };
  const showAssetDashboard = () => {
    saveAssetIdSearchParam(asset.id);
    push(`${SecurityRoutes.ACTIVITY.ASSET_DRILLDOWN}?assetId=${asset.id}`);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MoreActions, null, /* @__PURE__ */ React.createElement(MenuItem, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.search(`associated_assets:${asset.id}`, { relative: 0 }) }, /* @__PURE__ */ React.createElement("div", null, t("asset_entity_actions.search_for_asset")))), /* @__PURE__ */ React.createElement(MenuItem, { onClick: showAssetDashboard }, t("asset_entity_actions.asset_dashboard")), canManageAssets && !readOnly && /* @__PURE__ */ React.createElement(React.Fragment, null, formModal && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onEdit }, t("common:actions.edit")), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onClick: () => setShowDeleteModal(true) }))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      title: t("asset_entity_actions.delete_title"),
      onConfirm: onConfirmedDelete,
      onCancel: () => setShowDeleteModal(false),
      showModal: showDeleteModal
    },
    /* @__PURE__ */ React.createElement("div", null, t("asset_entity_actions.delete_text", { name: asset.name }))
  ));
};
export default AssetEntityActions;
